import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter3Questions = () => {
    const questions = [
      "What is the importance of quality improvement in healthcare?",
      "How does monitoring differ from evaluation?",
      "What are the key steps in conducting a quality improvement initiative?",
      "What tools are available for data collection in quality improvement?",
      "How can data visualization improve decision-making?",
      "What is the role of community engagement in the monitoring process?",
      "How does stakeholder feedback influence evaluation results?",
      "What are common barriers to successful quality improvement projects?",
      "How does evidence-based practice relate to quality improvement?",
      "What is the significance of continuous monitoring in achieving health outcomes?"
    ];
  
    return (
      <div>
        <StickyNavbar />
        <div className="bg-gray-50 min-h-screen p-8 mt-10">
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-8"
          >
            <h1 className="text-3xl font-bold text-blue-900">
              Chapter 3 Questions
            </h1>
          </motion.div>
          <motion.ul
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="space-y-4 text-lg"
          >
            {questions.map((question, index) => (
              <motion.li
                key={index}
                whileHover={{ scale: 1.05, x: 10 }}
                className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
              >
                {index + 1}. {question}
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    );
  };
  export default Chapter3Questions